/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import Dialog from "@mui/material/Dialog";
import { useDispatch, useSelector } from "react-redux";
import {
  closeDialog,
  selectBASEDialogOptions,
  selectBASEDialogState,
} from "../../../app/store/BASE/dialogSlice";

function BASEDialog(props) {
  const dispatch = useDispatch();
  const state = useSelector(selectBASEDialogState);
  const options = useSelector(selectBASEDialogOptions);

  return (
    <Dialog
      open={state}
      onClose={(ev) => dispatch(closeDialog())}
      aria-labelledby="base-dialog-title"
      classes={{
        paper: "rounded-8",
      }}
      {...options}
    />
  );
}

export default BASEDialog;
